module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-nav-content"
  }, [_c('div', {
    staticClass: "right-nav"
  }, [_c('ul', {
    staticClass: "nav-list"
  }, _vm._l((_vm.navList), function(navItem, index) {
    return _c('li', [_c('div', {
      staticClass: "nav-item",
      on: {
        "click": function($event) {
          _vm.goNav(navItem.id)
        }
      }
    }, [_vm._v(_vm._s(navItem.name))]), _vm._v(" "), _c('ul', {
      staticClass: "sub-nav-list"
    }, _vm._l((navItem.subcategorys), function(subNavItem) {
      return _c('li', {
        staticClass: "sub-nav-item",
        class: {
          active: _vm.currId == subNavItem.id
        },
        on: {
          "click": function($event) {
            _vm.goNav(subNavItem.id, subNavItem.parentId)
          }
        }
      }, [_vm._v(_vm._s(subNavItem.name))])
    }))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-131bc139","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home/classifyNavList.vue
// module id = 550
// module chunks = 1